export type TQmulusDropdownVariant = 'single' | 'multi' | 'filter';

export type TNamedOption<OPTION> = {
  value: OPTION,
  displayName: string,
};
export type TOption<OPTION> = OPTION | TNamedOption<OPTION>;

export function isNamedOption<OPTION>(option: TOption<OPTION>): option is TNamedOption<OPTION> {
  return typeof option === 'object'
    && option !== null
    && 'displayName' in option
    && 'value' in option;
}
